//Basic Map
export const BasicContainerStyle = {
  height: "500px",
};

export const BasicCenter = {
  lat: -3.745,
  lng: -38.523,
};

//Marker Map
export const MarkerContainerStyle = {
  height: "500px",
};

export const MarkerCenter = {
  lat: -3.745,
  lng: -38.523,
};

//PolygonCenter
export const PolygonContainerStyle = {
  height: "500px",
};

export const PolygonCenter = {
  lat: -3.745,
  lng: -38.523,
};

//PolylinesMapComp
export const PolylineContainerStyle = {
  height: "500px",
};

export const PolylineCenter = {
  lat: -3.745,
  lng: -38.523,
};

export const WORLD_MAP=[
    {
        text:"Below Map is displaying the world map."
    }
]

export const USA_MAP=[
    {
        text:"Below Map is displaying the USA map."
    }
]

export const USA_POSITION = { lat: 50, lng: 10 };

export const INDIA_MAP=[
    {
        text:"Below Map is displaying the India map."
    }
]

export const INDIA_POSITION = { lat: 20.5937, lng: 78.9629 };

export const AUSTRALIA_MAP=[
  {
      text:"Below Map is displaying the Australia map."
  }
]

export const AUSTRALIA_POSITION = { lat: -25.2744, lng: 130.7751 };
